
	import { Vue,Component,Prop,Model,Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import exicon from '../assets/expressicon'
    @Component
    export default class Excom extends Vue{
        @State('excom') excom:any
        @Model('change', { type: String }) value!: String
        excomIcon:string = '' //当前选择的快递公司图标
        val:any = ''
        exicon:any = exicon
        @Action('getExcom') getExcom:any
        async created(){
            await this.getExcom()
            this.val = this.value
            this.excom.map((item:any)=>{
                if(item._id == this.value){
                    this.excomIcon = item.pinyin
                } 
            })
        }
        change(e:any){
            this.$emit('change',e)
            if(e){
                this.excom.map((item:any)=>{
                    if(item._id == e){
                        this.excomIcon = item.pinyin
                    } 
                })
            }else{
                this.excomIcon = ''
            }
        }
        @Watch('value')
        onChildChanged(val: string, oldVal: string) {
            this.val = val
            this.excom.map((item:any)=>{
                if(item._id == val){
                    this.excomIcon = item.pinyin
                } 
            })
        }
    }
